import React, { Component } from 'react';
import GeckoLocation from 'services/gecko-location';
import { GeckoBtn } from 'ui';
import NewSkillField from '../NewSkillField';

import './index.scss';

class NewSkill extends Component {
  newSkill(type) {
    GeckoLocation.goTo(`/bots/${this.props.botId}/skills/${type}/new`);
  }

  handleCancel() {
    return GeckoLocation.goTo(`/bots/${this.props.botId}/skills`);
  }

  render() {
    return (
      <div className="NewSkill gecko-card card">
        <div className="NewSkill-header-container gecko-card-header">
          <div className="NewSkill-title">
            <h2 className="header-title">Add a New Skill</h2>
          </div>
          <GeckoBtn
            name={`Cancel\u2060`}
            handler={this.handleCancel.bind(this)}
            icon="far fa-times"
          />
        </div>
        <NewSkillField onChange={this.newSkill.bind(this)} />
      </div>
    );
  }
}

export default NewSkill;
